import dot from 'dot-object'
import Vue from 'vue'

Vue.prototype.$dot = dot
